"use client";

import Link from "next/link";
import { useState } from "react";

type Role = "particulier" | "architect" | "aannemer" | "ontwikkelaar";

type RoleCopy = Record<Role, { title: string; text: string }>;

const labels: Record<Role, string> = {
  particulier: "Particulier",
  architect: "Architect",
  aannemer: "Aannemer",
  ontwikkelaar: "Ontwikkelaar",
};

export function RouteContext({ copy }: { copy: RoleCopy }) {
  const [role, setRole] = useState<Role>("particulier");
  const selected = copy[role];

  return (
    <div className="route-context">
      <div className="route-role-tabs" role="group" aria-label="Kies jouw rol">
        {(Object.keys(labels) as Role[]).map((item) => (
          <button
            className={item === role ? "is-active" : ""}
            key={item}
            type="button"
            aria-pressed={item === role}
            onClick={() => setRole(item)}
          >
            {labels[item]}
          </button>
        ))}
      </div>
      <div className="route-role-answer" aria-live="polite">
        <p className="section-label">Voor {labels[role].toLowerCase()}</p>
        <h3>{selected.title}</h3>
        <p>{selected.text}</p>
        {role !== "particulier" && (
          <Link className="text-link" href={`/professionals?rol=${role}`}>
            Bekijk de samenwerking <span aria-hidden="true">→</span>
          </Link>
        )}
      </div>
    </div>
  );
}
